// eslint-disable-next-line no-use-before-define
import React from "react";
import PropTypes from "prop-types";
import { Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import useMessageContainerStyles from "../hooks/useMessageContainerStyles";

function NoResults({ title, show }) {
  const classes = useMessageContainerStyles();
  const { t } = useTranslation();

  const text = title != null ? title : t("noResults");

  if (show === true) {
    return (
      <div className={classes.actionContainer}>
        <Typography className={classes.text}>{text}</Typography>
      </div>
    );
  }
  return null;
}

NoResults.propTypes = {
  show: PropTypes.bool.isRequired,
  title: PropTypes.string,
};

NoResults.defaultProps = {
  title: null,
};

export default NoResults;
